module.exports = __webpack_public_path__ + "src/assets/ua.58d6fb3e.png";